import { Global, css } from '@emotion/react';

const style = css`
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');

  @font-face {
    font-family: 'Pretendard';
    src: url('https://img.mallpie.co.kr/fonts/Pretendard-Thin.woff')
      format('woff');
    font-style: normal;
    font-weight: 100;
  }

  @font-face {
    font-family: 'Pretendard';
    src: url('https://img.mallpie.co.kr/fonts/Pretendard-ExtraLight.woff')
      format('woff');
    font-style: normal;
    font-weight: 200;
  }

  @font-face {
    font-family: 'Pretendard';
    src: url('https://img.mallpie.co.kr/fonts/Pretendard-Light.woff')
      format('woff');
    font-style: normal;
    font-weight: 300;
  }

  @font-face {
    font-family: 'Pretendard';
    src: url('https://img.mallpie.co.kr/fonts/Pretendard-Regular.woff')
      format('woff');
    font-style: normal;
    font-weight: 400;
  }

  @font-face {
    font-family: 'Pretendard';
    src: url('https://img.mallpie.co.kr/fonts/Pretendard-Medium.woff')
      format('woff');
    font-style: normal;
    font-weight: 500;
  }

  @font-face {
    font-family: 'Pretendard';
    src: url('https://img.mallpie.co.kr/fonts/Pretendard-SemiBold.woff')
      format('woff');
    font-style: normal;
    font-weight: 600;
  }
  @font-face {
    font-family: 'Pretendard';
    src: url('https://img.mallpie.co.kr/fonts/Pretendard-Bold.woff')
      format('woff');
    font-style: normal;
    font-weight: 700;
  }
  @font-face {
    font-family: 'Pretendard';
    src: url('https://img.mallpie.co.kr/fonts/Pretendard-ExtraBold.woff')
      format('woff');
    font-style: normal;
    font-weight: 800;
  }
  @font-face {
    font-family: 'Pretendard';
    src: url('https://img.mallpie.co.kr/fonts/Pretendard-Black.woff')
      format('woff');
    font-style: normal;
    font-weight: 900;
  }

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
    font-family: 'Pretendard';
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  a {
    text-decoration: none;
  }
  span {
    font-size: inherit;
    font-weight: inherit;
  }

  * {
    box-sizing: border-box;
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: normal;
  }
`;

const GlobalStyle = () => <Global styles={style} />;
export default GlobalStyle;
